<template>
	<div>
		<div>
			<h2 class="mb-5 font-bold">{{ $t('change_password') }}</h2>
			<div class="flex">
				<div class="w-4/6">
					<div class="mb-3">
						<label class="block mb-2" for="name">{{
								$t('new_password')
						}}</label>
						<input v-model="password" class="
								w-full
								border-t-0
								border-r-0
								border-l-0
								border-b
								border-solid
								border-inputGrey
								outline-none
							" type="password" />
						<div v-if="$v.password.$dirty" class="text-left">
							<div class="text-sm text-red-500 mt-1" v-if="!$v.password.required">
								* {{ $t('new_password_requerida') }}
							</div>
							<div class="text-sm text-red-500 mt-1" v-if="!$v.password.minLength">
								* {{ $t('new_password_invalid') }}
							</div>
						</div>
					</div>
					<div>
						<label class="block mb-2" for="name">{{
								$t('confirm_new_password')
						}}</label>
						<input v-model="confirm_password" class="
								w-full
								border-t-0
								border-r-0
								border-l-0
								border-b
								border-solid
								border-inputGrey
								outline-none
							" type="password" />
						<div v-if="$v.confirm_password.$dirty" class="text-left">
							<div class="text-sm text-red-500 mt-1" v-if="!$v.confirm_password.required">
								* {{ $t('confirm_password_requerida') }}
							</div>
							<div class="text-sm text-red-500 mt-1" v-if="!$v.confirm_password.minLength">
								* {{ $t('confirm_password_invalid') }}
							</div>
							<div class="text-sm text-red-500 mt-1" v-if="!$v.confirm_password.sameAsPassword">
								* {{ $t('new_password_validation') }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="flex justify-end">
				<ButtonBlack class="mt-4" @click.native="submit">
					<div v-if="loading">
						<pulse-loader :loading="loading" :color="'#fff'" :size="'10px'"></pulse-loader>
					</div>
					<div v-else>
						{{ $t('update') }}
					</div>
				</ButtonBlack>
			</div>
			<div v-if="error" class="mt-4 text-sm">
				<p>{{ $t('server_error') }}.</p>
				<p class="text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</div>
</template>

<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { single } from '@/mixins'
import { updateUserPassword } from '@/apollo/users'

export default {
	mixins: [single],
	components: { PulseLoader },
	data() {
		return {
			password: '',
			confirm_password: ''
		}
	},
	validations: {
		password: {
			required,
			minLength: minLength(8)
		},
		confirm_password: {
			required,
			minLength: minLength(8),
			sameAsPassword: sameAs('password')
		}
	},
	methods: {
		submit() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				this.updateUser()
					.then(() => {
						this.stopLoadingState()
						this.$alert("Tu contraseña está actualizada", "¡Enhorabuena!", "success")
					})
					.catch(error => {
						this.setError(error)
						this.$alert(error, "Error", "error")
					})
			} else {
				this.setError(this.$t('form_validation'))
				this.$alert(this.$t('form_validation'), "Advertencia", "warning")
			}
		},
		updateUser() {
			return this.$apollo.mutate(
				updateUserPassword(this.$store.state.login.user.id, this.password)
			)
		}
	}
}
</script>
